const DefaultSKin = {
    "id": 1,
    "name": "Default",
    "color_control_bar": "rgba(0, 0, 0, 1)",
    "color_primary": "rgba(230, 68, 68, 1)",
    "color_secondary": "rgba(255, 255, 255, 1)",
    "color_background": "rgba(0, 0, 0, 1)",
    "control_play_pause_btn": 1,
    "control_stop_btn": 0,
    "control_progress_bar": 1,
    "control_volume": 1,
    "control_subtitles": 1,
    "control_transcript": 1,
    "control_quality": 1,
    "control_time": 1,
    "control_speed": 1,
    "control_audio_tracks": 1,
    "control_audio_description": 1,
    "control_chapters": 0,
    "control_pip": 1,
    "control_fullscreen": 1,
    "control_share": 1,
    "control_extract": 0,
    "info_title": 1,
    "info_desc": 1,
    "info_date": 1,
    "info_views": 1,
    "info_duration": 1,
    "info_thumbnail": 1,
    "info_files": 1,
    "info_chapters": 1,
    "info_copyright": 1,
    "info_logo": 1,
    "info_privacy_url": 0,
    "info_stats": 0,
    "info_shortcuts":1,
    "info_empreinte":1,
    "action_rate": 1,
    "action_download_video": 1,
    "action_download_files": 1,
    "action_download_transcript": 1,
    "action_loop": 1,
    "is_editable": 0
}
const state = {
    currentTime: 0,
    videoInfos: [],
    playlist: [] ,
    hasInfo: [],
    skinInfos:DefaultSKin,
    skinPreview: false, 
    PlayerReady: false, 
    extractInfos:null


    
}

const mutations = {
    setCurrentTime(state, time) {
        state.currentTime = time;
    },
    setVideoInfos(state, data) {
        state.videoInfos = data;
    },
    setPlaylist(state, playlist) {
        state.playlist = playlist;
 },
sethasInfo(state, hasInfo) {
    state.hasInfo = hasInfo;
},
setSkinInfos(state, data) {
    state.skinInfos = data;
},
setSkinMode(state, data) {
    state.skinPreview = data;
},


setExtractInfos(state,data){
    state.extractInfos=data
    }

};

const actions = {
    updateCurrentTime({ commit }, time) {
        commit('setCurrentTime', time);
    },
    updateVideoInfos({ commit }, data) {
        commit('setVideoInfos', data);
    },
    setSkinInfos({ commit }, data) {
        const root = document.querySelector(':root');
    
        const rgbaToRgb = (rgba) => {
            const rgbaArray = rgba.match(/\d+/g);
            return rgbaArray.slice(0, 3).join(', ');
        };
    
        root.style.setProperty('--base-color-one', rgbaToRgb(data.color_control_bar));
        root.style.setProperty('--base-color-two', rgbaToRgb(data.color_primary));
        root.style.setProperty('--base-color-three', rgbaToRgb(data.color_secondary));
        root.style.setProperty('--base-color-four', rgbaToRgb(data.color_background));
    
        commit('setSkinInfos', data);
    },
    setSkinPreview({ commit }, data) {
        commit('setSkinMode', data);
    }, 
    setExtractVideoInfos({ commit }, data) {
        commit('setExtractInfos', data);
    }, 

};

const getters = {
    getCurrentTime: (state) => state.currentTime,
    setVideoInfos: (state) => state.videoInfos,
    getPlaylist: (state) => state.playlist ,
    gethasInfo: (state) => state.hasInfo,
    getSkinInfos:(state)=>state.skinInfos,
    getSkinPreview:(state)=>state.skinPreview,
    getExtractInfos:(state)=>state.extractInfos

}

export default {
    state,
    getters,
    actions,
    mutations
}